module.exports = __webpack_public_path__ + "static/media/node.3b12f93b.png";